import SearchField from './SearchField';

export const PARAM_SEARCH = 'search';

export default SearchField;
